import { render, staticRenderFns } from "./Talk3.vue?vue&type=template&id=dffdf53a&scoped=true"
import script from "./Talk3.vue?vue&type=script&lang=js"
export * from "./Talk3.vue?vue&type=script&lang=js"
import style0 from "./Talk3.vue?vue&type=style&index=0&id=dffdf53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffdf53a",
  null
  
)

export default component.exports